import { render, staticRenderFns } from "./viewTaxRatesModal.vue?vue&type=template&id=00a95110&scoped=true"
import script from "./viewTaxRatesModal.vue?vue&type=script&lang=js"
export * from "./viewTaxRatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a95110",
  null
  
)

export default component.exports